const logoNames = {
  lacera: "LACERA",
  cvs: "CVS",
  db: "Deutsche Bank",
  jmbm: "JMBM",
  toyota: "Toyota",
  wendys: "Wendy's",
  petsmart: "PetSmart",
  akerman: "Akerman",
  aldi: "ALDI",
  amc: "AMC Theatres",
  uscis: "U.S. Citizenship and Immigration Services",
  stjude: "St. Jude Children's Research Hospital",
  bb: "Best Buy",
  kp: "Kaiser Permanente",
  starbucks: "Starbucks",
  porsche: "Porsche",
  dws: "DWS",
  rreef: "RREEF",
}

// Descriptions reviewed against the seven photographs in the About slideshow.
const portfolioPhotos = {
  "5b7e17cf51ca464dac96f6c90548621c62443c7a3c2a4fc280d3df635b077636":
    "AMC cinema entrance at dusk, with illuminated AMC and IMAX signs and a glass-fronted lobby",
  "8607212d72094ff4a7d2f317a8b31ee24064291734c04934b9aa596c1266c4a3":
    "Two-story office building at dusk, with a glass-fronted entrance and landscaped driveway",
  "5f680dcfd2eb4be3bd24f14e74533de358e071faa096402f9884b0499fc4074e":
    "Landscaped office courtyard with benches, planters, and an upper-floor balcony",
  "539b300ca5be457a80bb81be556d53e0faaa8d475bbf4299ae635110aa99755c":
    "Four-story hotel exterior with palm trees and parking in front of the entrance",
  "0c217f138eac49b4b8b22dd3d6f837045a3fb1f3645047b6a51983767db4e649":
    "Industrial building with a two-story glass-fronted office entrance and landscaped street frontage",
  "89b1f6d1302347f7b33aec39be273bafaf186f9ff8b04c3b9da5f44464e0c422":
    "Aerial view of commercial buildings, parking areas, and a palm-lined road",
  c4358dda0da947a081b413ef96d0609ca10140cfd04747d7b40d0fcc74339492:
    "ALDI supermarket exterior at dusk, with illuminated signage and storefront windows",
}

const getImageAlt = (
  image,
  fallback = "Commercial real estate project developed by Exdev"
) => {
  const candidates = [image.description, image.title].filter(Boolean)
  const description = candidates.find(
    (text) => !/^(uob page|new about page portfolio image)/i.test(text)
  )
  if (description) return description

  const logoTitle = candidates.find((text) => /^uob page .+ logo$/i.test(text))
  if (logoTitle) {
    const code = logoTitle.replace(/^uob page | logo$/gi, "").toLowerCase()
    return `${logoNames[code] || code.toUpperCase()} logo`
  }

  const source =
    typeof image.image === "string"
      ? image.image
      : (image.image && (image.image.original || image.image.large)) || ""
  const photoKey = Object.keys(portfolioPhotos).find((key) =>
    source.includes(key)
  )
  return portfolioPhotos[photoKey] || fallback
}

export default getImageAlt
